module.exports = __webpack_public_path__ + "static/media/hamburguerPromoGpSp2023.e69a738d.svg";